// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1VCFh","boxTitle":"Qualiphy_boxTitle__1t0QT","box":"Qualiphy_box__24AV_","toggleWrap":"Qualiphy_toggleWrap__1oL_y"};